<app-header class="layout-header" [menuToggleEnabled]="true" (menuToggle)="menuOpened = !menuOpened" [appTitle]="appTitle" [title]="title">
</app-header>
<div class="d-flex flex-row w-100" style="flex-grow: 1;">
    <div class="dx-theme-accent-as-background-color" style="width: 25px; flex-shrink: 0; xbackground-color: #275296;"></div>
    <div class="content main-content" style="width: 100vh;">
        <ng-content></ng-content>
    </div>
</div>
